import {Component, inject, Inject, OnInit} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
// @ts-ignore
import {AppStore, ReloadDocumentListAction} from '@alfresco/aca-shared/store';
import {Store} from '@ngrx/store';
import {RenameService} from "../../../../services/rename.service";

@Component({
  standalone: false,
  selector: 'app-rename-dialog',
  templateUrl: './rename-dialog.component.html'
})
export class RenameDialogComponent implements OnInit {
  public newName: any = "";
  protected store = inject<Store<AppStore>>(Store<AppStore>);
  typeDocument: any;
  error: string = '';

  constructor(
    private renameService: RenameService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<RenameDialogComponent>
  ) {
  }

  ngOnInit() {
    this.typeDocument = this.data.isFolder ? 'dossier' : 'document';
    this.newName = this.data.name;
  }

  onSubmit() {
    if(this.data.isFolder || (!this.data.isFolder && this.checkIfExtensionIsPresent(this.newName))) {
      if (this.newName && this.data.name !== this.newName) {
        this.renameService.rename(this.data, this.newName).subscribe(() => {
          this.store.dispatch(new ReloadDocumentListAction());
          this.dialogRef.close();
        });
      } else {
        this.error = 'Veuillez saisir un nom différent pour votre ' + this.typeDocument + '.';
      }
    } else {
      this.error = 'Veuillez ajouter une extension à votre document. (Exemple : .pdf, .docx, ...)';
    }

  }

  checkIfExtensionIsPresent(name: string) {
    return name.lastIndexOf('.') > 0;
  }
}
